export default __webpack_public_path__ + "static/media/arrow_left_white.a0816b3c.svg";